import axios from '@/utilities/axios-global'
import { Message, MessageBox } from 'element-ui'

function formatAllowedDomains(allowedDomainsByClient, clientsWithoutDomain) {
  if (!allowedDomainsByClient || !clientsWithoutDomain || !clientsWithoutDomain.length) {
    return 'none on file'
  }

  return clientsWithoutDomain
    .map(client => {
      const domains = allowedDomainsByClient[client] || []
      const list = domains.length ? domains.join(', ') : 'none on file'
      return `<strong>${client}</strong>: ${list}`
    })
    .join('<br>')
}

export function buildDomainConfirmMessage(data) {
  const clients = data.clientsWithoutDomain || []
  const facilityLabel = clients.length === 1 ? 'this facility' : 'these facilities'
  const allowedSummary = formatAllowedDomains(data.allowedDomainsByClient, clients)
  return (
    `<span>` +
    `You are about to add a user with email domain <strong>${data.domain}</strong>.<br><br>` +
    `<strong>Facilities missing this domain:</strong><br>${clients.join('<br>')}<br><br>` +
    `<strong>Current allowed domains:</strong><br>${allowedSummary}<br><br>` +
    `If you continue, <strong>${data.domain}</strong> will be added to the allowed domain list for ${facilityLabel}.` +
    `<br><br>Type <strong>continue</strong> to confirm.` +
    `</span>`
  )
}

function distinctClientNumbers(clientNumbers, fallbackClientNumber) {
  const fromList = (clientNumbers || []).filter(Boolean)
  const unique = [...new Set(fromList)]
  if (unique.length) {
    return unique
  }
  return fallbackClientNumber ? [fallbackClientNumber] : []
}

/**
 * @param {string} baseApiUrl
 * @param {string} emailAddress
 * @param {string} clientNumber route/current client fallback
 * @param {string[]} [clientNumbers] clients receiving roles (preferred for IT multi-facility create)
 */
export async function validateAndMaybeAddEmailDomain(baseApiUrl, emailAddress, clientNumber, clientNumbers) {
  const clientsToCheck = distinctClientNumbers(clientNumbers, clientNumber)
  const response = await axios.post(`${baseApiUrl}/useradmin/validate-email-domain`, {
    emailAddress,
    contactRoles: clientsToCheck.map(c => ({ clientNumber: c }))
  })
  const data = response.data || {}

  if (data.isCommercial) {
    Message({
      message: data.message || `Commercial email domains such as ${data.domain} are not allowed.`,
      type: 'error',
      duration: 6000
    })
    return false
  }

  if (data.clientsWithoutDomain && data.clientsWithoutDomain.length) {
    try {
      await MessageBox.prompt(buildDomainConfirmMessage(data), 'New Email Domain Confirmation', {
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
        type: 'warning',
        dangerouslyUseHTMLString: true,
        inputPlaceholder: 'Type continue',
        inputValidator: value => {
          if (!value || value.trim().toLowerCase() !== 'continue') {
            return 'Type continue to proceed'
          }
          return true
        }
      })

      await axios.post(`${baseApiUrl}/useradmin/allowed-domains`, {
        domain: data.domain,
        emailAddress,
        clientNumbers: data.clientsWithoutDomain
      })
    } catch (e) {
      return false
    }
  }

  return true
}
